/*
 * @Descripttion: 招贤纳士
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2022-07-20 17:08:13
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2023-04-10 11:56:41
 */

const job = {
  title: '招贤纳士',
  des: 'Join ArteryFlow',
  info: [
    '无限可能，等你探索',
    '多元的培养模式与广阔的发挥空间',
    '从不缺少让你绽放光芒的舞台',
    '无限可能，等你探索',
    '我们是一家<span class="fontw">专注于面向全球提供领先的心脑血管疾病智能解决方案</span>的国家高新技术企业',
    '一支以“<span class="fontw">创新、精准、高效、卓越</span>”为核心价值观的学霸级团队',
    '我们年轻，心怀远大，满腹激情与活力',
    '我们有来自全球知名学府的技术大咖',
    '加入脉流，和我们一起勾勒医学产品的未来',
    '和我们一起深耕于心脑血管病领域的蓝海'
  ],
  welfare: {
    title: '薪酬与福利，极具竞争力',
    des: '优厚的薪酬与福利，是你追梦路上的坚强后盾，为你扫除后顾之忧',
    list: [
      {
        title: '薪酬及五险一金',
        img: require('@/assets/images/job/1.png')
      },
      {
        title: '带薪年假',
        img: require('@/assets/images/job/2.png')
      },
      {
        title: '工龄补贴',
        img: require('@/assets/images/job/3.png')
      },
      {
        title: '餐费补贴',
        img: require('@/assets/images/job/12.png')
      },
      {
        title: '交通费补贴',
        img: require('@/assets/images/job/11.png')
      },
      {
        title: '年终奖金',
        img: require('@/assets/images/job/10.png')
      },
      {
        title: '节日关怀',
        img: require('@/assets/images/job/6.png')
      },
      {
        title: '生日Party',
        img: require('@/assets/images/job/7.png')
      },
      {
        title: '学习培训',
        img: require('@/assets/images/job/8.png')
      },
      {
        title: '团建活动',
        img: require('@/assets/images/job/4.png')
      },
      {
        title: '股权激励',
        img: require('@/assets/images/job/9.png')
      },
      {
        title: '员工活动',
        img: require('@/assets/images/job/5.png')
      }
    ]
  },
  recruit: {
    title: '我们正在广泛招募',
    des: '产品研发、算法、深度学习科研、市场公关、销售、人力行政人员等',
    boss: 'https://www.zhipin.com/gongsir/afc6ac46e9c2e9af33Fz0t6_.html?ka=company-jobs',
    list: [
      {
        id: '0_1',
        title: '临床医学',
        des: '经理',
        type: '临床',
        num: '2人',
        time: '2022-05-12',
        address: '全国',
        experience: '5年及以上',
        education: '本科',
        content: ['临床项目执行过程管理，有效推进临床项目。', '合同研究组织（CRO）和SMO的筛选、评估和管理。', '临床试验预算及合同管理。', '保证临床试验合规性与质量。', '组织临床试验申报资料（临床相关部分）的撰写及审核。', '按照临床项目的具体需求，负责相关的工作。', '组织医生进行用户测试，并编写用户测试报告。'],
        requirement: ['临床医学、药学专业或相关专业本科以上学历。', '至少5年临床试验工作或者2-3年的临床试验供应商管理经验。', '熟知 GCP、法规对医疗器械临床研究的要求。', '具有独立工作能力，同时又具有强烈的团队合作精神；能够快速融入团队、以及奉献精神。', '具有优秀的项目管理沟通技能，如组织召开项目组会议，针对出现的问题能迅速反应并拿出解决方案。', '需要有医疗器械GCP证书。'],
        hot: true
      }, {
        id: '0_2',
        title: '国外注册',
        des: '工程师',
        type: '注册师',
        num: '1人',
        time: '2022-05-12',
        address: '杭州',
        experience: '2年',
        education: '本科',
        content: ['负责公司FDA和CE认证项目的推进；', '负责收集目标市场相关法规标准，以及法规标准需求、注册路径的内部输入；', '负责向监管机构和主管当局报告不良事件和召回；', '将国外相关信息与公司内各部门有效沟通，确保项目顺利进行；', '完成上级交办的其他工作。'],
        requirement: ['本科及以上学历；', '熟悉海外医疗器械产品认证和注册流程；', '2年及以上医疗器械国际注册工作经验；', '良好的英语读写能力，能独立完成英文注册资料的准备工作；', '熟悉FDA 510K医疗器械产品注册流程和欧盟CE认证，或者有成功欧美注册认证经验者优先考虑；', '良好的沟通能力和执行力，学习能力强，做事认真踏实；', '有独立软件FDA注册经验优先考虑。', '完成领导安排的其他事情。'],
        hot: true
      }, {
        id: '0_3',
        title: '销售',
        des: '经理',
        type: '市场营销',
        num: '1人',
        time: '2022-05-12',
        address: '全国',
        experience: '3年',
        education: '大专',
        content: ['负责公司心血管产品、颅内产品在区域内目标医院的临床推广；', '通过科室会、区域学术会正确传递产品信息，达成销售目标；', '开拓潜在的医院渠道客户，并对既有的客户进行维护；', '建立并维护当地的专家网络；', '积极了解并反馈市场需求、产品竞争等情况；', '跟进项目进展，促进项目顺利进行，负责所辖地区医院销量统计。'],
        requirement: ['医学、药学、生物学及市场营销相关专业大专及以上学历；', '1年以上公司销售经验，销售业绩突出，有医疗行业销售经验的优先考虑；', '良好的学术推广能力和执行力；', '能承受较大的工作压力，勇于开拓和挑战，适应出差。'],
        hot: true
      }, {
        id: '0_4',
        title: '国内注册',
        des: '工程师',
        type: '注册师',
        num: '1人',
        time: '2022-05-12',
        address: '杭州',
        experience: '2年',
        education: '本科',
        content: ['负责产品送检事宜，与检验院对接沟通事宜，将检验院的要求及时进行反馈；', '负责医疗器械从注册、生产许可及其他医疗器械相关申报事项；包含相关资料的汇编及申报提交。'],
        requirement: ['本科以上相关学历，机械、软件、医疗器械等理工科相关专业优先；', '至少有三年有源、软件等相关注册工作经验；', '熟悉医疗器械产品注册申报流程以及注册相关法律法规，有三类医疗器械注册经验者优先；', '有责任心，工作态度严谨、细致、较强的沟通与学习能力，能独立完成工作优先；', '具备体系认证经验优先'],
        pending: true
      }, {
        id: '0_5',
        title: 'FEA',
        des: '工程师',
        type: '技术岗',
        num: '2人',
        time: '2021-11-19',
        address: '杭州',
        experience: '经验不限',
        education: '硕士',
        content: ['主要负责FEA商业软件和开源软件在医疗虚拟治疗（包括心脑血管支架、心脏瓣膜等）方面的仿真计算；', '针对具体FEA医学工程问题进行仿真分析工作，策划技术路线与解决方案；', '负责撰写相关的报告和论文；', '负责与客户相关FEA技术的交流讨论和技术支持工作。'],
        requirement: ['硕士及以上学历，固体力学、材料力学、机械工程及相关专业，有丰富的FEA仿真经验；海外背景博士优先考虑；', '熟练使用CAE仿真软件，比如ABAQUS、ANSYS等；', '熟练使用3D建模软件，比如Solidworks， Pro/E等；', '在血管和医疗器械FEA仿真方面有研究和工作经历（比如心脑血管支架、心脏瓣膜等）的优先考虑；', '有编程经验的优先考虑，包括objective C/C++， Matlab等；', '有CFD经验的优先考虑，包括使用商业软件（ANSYS、 Fluent、StarCD、StarCCM+）和开源软件（OPENFOAM、XFLOW）；', '有医学图像（DSA, CTA, MRA）重构方面经验者优先考虑；', '专业的英语能力良好优先考虑。'],
        pending: true
      }, {
        id: '0_6',
        title: 'CFD',
        des: '工程师',
        type: '技术岗',
        num: '若干',
        time: '2021-11-19',
        address: '杭州',
        experience: '经验不限',
        education: '硕士',
        content: ['开发CFD源代码；', '在开源CFD程序的基础上进行二次CFD技术模块开发。'],
        requirement: ['至少硕士学历，具有流体力学背景；海外背景优先考虑；', '申请人须有CFD程序开发经验，应掌握C/C++/Fortran等编程能力，有CFD云计算背景有限考虑；', '熟练应用CFD开源程序，比如Openfoam，或者基于LBM的开源程序；', '熟练掌握CFD前处理技巧（几何处理和网格生成）和后处理技术（数据可视化，比如paraview）；', '有血管FFR仿真计算经验者优先；有仿真多个出口应用RCR边界条件仿真经验者优先；', '有三维医学图像重构开源代码开发经验者优先；', '有较强的学习能力和解决问题的能力，有学习新知识、新技能的愿望和动力。'],
        pending: true
      }
    ],
    listMore: '了解更多',
    more: '了解更多热招岗位',
    num: '招聘人数',
    address: '工作地点',
    experience: '工作经验',
    education: '学历要求',
    jobDetails: '岗位详情',
    jobType: '职位类型',
    updateTime: '更新时间',
    content: '工作内容',
    jobRequirements: '任职要求',
    apply: '我要申请',
    collect: '收藏职位',
    pending: '准备中',
    hot: '热招中'
  }
}

export default job
